import { useSelector } from 'react-redux'

import { getPastTimes, useCheckForEmptyData, useCheckForTeamSetUpEmptyData } from 'features/reporting'
import { isSingleSelector } from 'selectors/current_organization'
import { timezoneSelector } from 'selectors/current_user'

export const useExperimentEmptyState = () => {
  const isSingleOrganization = useSelector(isSingleSelector)
  const timezone = useSelector(timezoneSelector)
  const { end, start } = getPastTimes(timezone, 7)
  const isEmptyData = useCheckForEmptyData({ start, end, timezone })
  const isEmptyTeamData = useCheckForTeamSetUpEmptyData()

  return isEmptyData && (isSingleOrganization || isEmptyTeamData)
}
